import request from '@/utils/request'

// 获取号码库列表
export function getPhoneBankList(params) {
  return request({
    url: '/enrollment/phoneBank/list',
    method: 'get',
    params
  });
}

// 查询号码库详情
export function getPhoneBankDetail(phoneBankId) {
  return request({
    url: '/enrollment/phoneBank/' + phoneBankId,
    method: 'get'
  });
}

// 查询号码库跟进记录
export function getFollowList(phoneBankId) {
  return request({
    url: '/enrollment/phoneBank/getFollowList/' + phoneBankId,
    method: 'get'
  });
}

// 添加号码库跟进记录
export function addPhoneBankFollow(data) {
  return request({
    url: '/enrollment/phoneBank/followUp',
    method: 'put',
    data
  });
}

// 查询统计信息
export function getUserAllocationInfoForPhone() {
  return request({
    url: '/enrollment/phoneBank/getUserAllocationInfoForPhone',
    method: 'get'
  });
}

// 结转至公海
export function transferred(phoneBankId) {
  return request({
    url: '/enrollment/phoneBank/transferred/' + phoneBankId,
    method: 'put'
  });
}